<template>
	<div class='knd-header' >
    <div class="knd-wrapper m-auto">
      <div class="knd-wrapper-inner">
        <h2>{{data.title}}</h2>
        <h4>{{data.subtitle}}</h4>
        <div v-html="data.lead"></div>
      </div>
   </div>
	</div>
</template>

<script>

import { useStore } from 'vuex'

export default {
  setup () {
    const store = useStore()

    return {
      data: store.getters.data
    }
  }
}
</script>

<style lang="scss">
  .knd-header {
    padding-top: 4em;
    min-height: 60vh;
  }
</style>